export default __webpack_public_path__ + "static/media/Question.709d56c4.svg";